<template>
  <div>
    <h6>{{ label }}</h6>

    <template v-if="visibleItems.length">
      <router-link
        v-for="enq in visibleItems"
        :key="enq.id"
        :to="{ name: 'Enquiry Overview', params: { id: enq.id } }"
        tag="div"
        class="enquiry-item md-layout enquiry-follow-up"
      >
        <div class="md-layout-item md-size-40 customer">
          <i v-if="isNew(enq)" class="fas fa-bolt text-warning new-icon">
            <md-tooltip md-direction="right">New Enquiry</md-tooltip>
          </i>
          {{ enq.customer }}
        </div>

        <div class="md-layout-item md-size-30 follow-up-date">
          {{ enq.follow_up | formatDateShort }}
        </div>

        <div
          class="md-layout-item md-size-30 heat text-right"
          :class="ratingColour(enq.heat)"
        >
          <i v-for="(n, i) in enq.heat" :key="i" class="fas fa-star"></i>
        </div>
      </router-link>

      <transition name="expand">
        <div v-show="expanded">
          <router-link
            v-for="enq in extraItems"
            :key="enq.id"
            :to="{ name: 'Enquiry Overview', params: { id: enq.id } }"
            tag="div"
            class="enquiry-item md-layout enquiry-follow-up"
          >
            <div class="md-layout-item md-size-40 customer">
              <i v-if="isNew(enq)" class="fas fa-bolt text-warning new-icon">
                <md-tooltip md-direction="right">New Enquiry</md-tooltip>
              </i>
              {{ enq.customer }}
            </div>

            <div class="md-layout-item md-size-30 follow-up-date">
              {{ enq.follow_up | formatDateShort }}
            </div>

            <div
              class="md-layout-item md-size-30 heat text-right"
              :class="ratingColour(enq.heat)"
            >
              <i v-for="(n, i) in enq.heat" :key="i" class="fas fa-star"></i>
            </div>
          </router-link>
        </div>
      </transition>

      <md-button v-if="showToggle" class="md-primary md-dense" @click="toggle">
        {{ expanded ? "See less" : "See more" }}
      </md-button>
    </template>

    <p v-else>
      <strong>Good Job!</strong> No {{ emptyText }} follow-ups needed today.
    </p>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "EnquiryFollowUpsList",

  props: {
    label: String,
    items: Array,
    emptyText: String,
    limit: { type: Number, default: 5 }
  },

  data() {
    return {
      expanded: false
    };
  },

  computed: {
    visibleItems() {
      return this.items.slice(0, this.limit);
    },
    extraItems() {
      return this.items.slice(this.limit);
    },
    showToggle() {
      return this.items.length > this.limit || this.expanded;
    }
  },

  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },

    ratingColour(heat) {
      if (heat <= 2) return "cool";
      if (heat === 3) return "medium";
      if (heat >= 4) return "hot";
      return "";
    },

    isNew(enq) {
      const created = moment(enq.created_at);
      const followUp = moment(enq.follow_up);
      const daysOld = moment().diff(created, "days");
      return daysOld <= 3 && created.isSame(followUp, "day");
    }
  }
};
</script>

<style scoped>
.enquiry-follow-up {
  padding: 3px 0px;
  border-bottom: 1px solid #d2d2d2;
  cursor: pointer;
}

.new-icon {
  margin-right: 5px;
  font-size: 14px;
}

/* Animation */
.expand-enter-active,
.expand-leave-active {
  transition: max-height 0.35s ease, opacity 0.25s ease;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  max-height: 500px;
}
</style>
